// frontend/src/hooks/useSupportMutation.js
//
// TanStack mutation wrapper for POST /api/support/contact/.
//
// Fire-and-forget — there's no cache to invalidate on success. The
// modal owns the lifecycle (pending state, error translation, success
// screen).
//
// Auto-attaches diagnostic context the backend can't derive from
// request state on its own:
//   - route     : current pathname so triage knows which screen the
//                 merchant was on
//   - viewport  : "{w}x{h}" so layout-bug reports include the screen
//                 size without a follow-up email
//   - surface   : 'saas'
//
// Identity (user / organization / store) comes from authenticated request
// state server-side — it is NOT sent in the body.

import { useApiMutation } from '../queries/useApiMutation';
import { apiJson } from '../queries/api';

export function useSupportMutation({ onSuccess, onError } = {}) {
  return useApiMutation({
    // A support request is not store data.
    changes: [],
    mutationFn: (vars) => {
      const { subject, message, category, sendCopy } = vars;
      const viewport = typeof window !== 'undefined'
        ? `${window.innerWidth}x${window.innerHeight}`
        : '';
      const route = typeof window !== 'undefined'
        ? window.location.pathname
        : '';
      return apiJson.post('/api/support/contact/', {
        subject,
        message,
        category,
        send_copy: !!sendCopy,
        route,
        viewport,
        surface: 'saas',
      });
    },
    onSuccess,
    onError,
  });
}
